import Icon from 'veui/components/Icon'

Icon.register({
  move: {
    paths: [
      {
        d: 'M30.28 15.06l-4-4a1.33 1.33 0 10-1.89 1.88l1.72 1.73h-8.78V5.89l1.73 1.72a1.33 1.33 0 101.88-1.89l-4-4a1.33 1.33 0 00-1.88 0l-4 4a1.33 1.33 0 101.88 1.89l1.73-1.72v8.78H5.89l1.72-1.73a1.33 1.33 0 10-1.89-1.88l-4 4a1.33 1.33 0 000 1.88l4 4a1.33 1.33 0 101.89-1.88l-1.72-1.73h8.78v8.78l-1.73-1.72a1.33 1.33 0 10-1.88 1.89l4 4a1.33 1.33 0 001.88 0l4-4a1.33 1.33 0 10-1.88-1.89l-1.73 1.72v-8.78h8.78l-1.72 1.73a1.33 1.33 0 101.89 1.88l4-4a1.33 1.33 0 000-1.88z'
      }
    ],
    width: '32',
    height: '32'
  }
})
